module.exports = __webpack_public_path__ + "img/gal-9.f8cf572c.jpg";